import { tns } from "tiny-slider/src/tiny-slider";

for (let i = 0; i < $(".slider").length; i++) {
  if (
    $(".slider").eq(i).find(".slider__wrapper").children().length > 4 &&
    $(window).width() > 1539
  ) {
    sliderInit(i);
  } else if (
    $(".slider").eq(i).find(".slider__wrapper").children().length > 3 &&
    $(window).width() > 1199 &&
    $(window).width() < 1540
  ) {
    sliderInit(i);
  } else if (
    $(".slider").eq(i).find(".slider__wrapper").children().length > 2 &&
    $(window).width() > 767 &&
    $(window).width() < 1200
  ) {
    sliderInit(i);
  } else if (
    $(".slider").eq(i).find(".slider__wrapper").children().length > 1 &&
    $(window).width() < 768
  ) {
    sliderInit(i);
  } else {
    $(".slider")
      .eq(i)
      .find(".slider__wrapper")
      .addClass("no-active")
      .css("width", $(".container").width());
    $(".slider").eq(i).find(".slider__control").css("display", "none");
  }
}

function sliderInit(i) {
  const id = $(".slider").eq(i).find(".slider__wrapper").data("id");
  const edgePadding =
    $(window).width() -
    (($(window).width() - $(".container").width()) / 2 +
      $(".container").width());

  let slider = tns({
    container: ".slider .slider__wrapper[data-id='" + id + "']",
    gutter: 20,
    nav: false,
    loop: false,
    speed: 800,
    edgePadding: edgePadding,
    controlsContainer: ".slider__control[data-id='" + id + "']",
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 2,
      },
      1200: {
        items: 3,
      },
      1540: {
        items: 4,
      },
    },
  });
}
